module.exports = __webpack_public_path__ + "static/media/sell_start_service_help_3.82bcea40.jpg";